import { z } from 'zod';
import { objectIdSchema } from './objectId';

export const BrandEventHighlightSchema = z.object({
  _id: objectIdSchema,
  name: z.string(),
});
